import {createTheme, StyledEngineProvider, ThemeProvider} from '@mui/material/styles';
import React, {useEffect} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import routes from '../routes';
import {API} from '../services/API';
import {getUser} from '../store/actions/auth';
import Access from './access/Access';
import Admin from './admin/Admin';
import './App.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#FDB714',
      contrastText: '#5B686B'
    },
    secondary: {
      main: '#5B686B',
      contrastText: '#fff'
    },
    background: {
      default: '#e9e9e9',
    },
    contactType: {
      all: {
        main: '#111111'
      },
      customer: {
        main: '#85da4f'
      },
      supplier: {
        main: '#3ed3e7',
      },
      prospect: {
        main: '#ffa728',
      },
      transporter: {
        main: '#7728ff',
      },
    },
    orderStatus: {
      ongoing: {
        main: '#FDB714',
        contrastText: '#fff'
      },
      locked: {
        main: '#73c241',
        contrastText: '#fff'
      },
      pending: {
        main: '#ec961b',
        contrastText: '#fff'
      },
      delivered: {
        main: '#4bafe8',
        contrastText: '#fff'
      },
      weighed: {
        main: '#a14be8',
        contrastText: '#fff'
      },
      checked: {
        main: '#e84b4b',
        contrastText: '#fff'
      },
      invoiced: {
        main: '#604be8',
        contrastText: '#fff'
      },
      held: {
        main: '#bfbfbf',
        contrastText: '#fff'
      },
      cancelled: {
        main: '#7e7e7e',
        contrastText: '#fff'
      },
      all: {
        main: '#000',
        contrastText: '#fff'
      },
    },
    inboxStatus: {
      unread: {
        main: '#FDB714',
        contrastText: '#fff'
      },
      open: {
        main: '#73c241',
        contrastText: '#fff'
      },
      closed: {
        main: '#e84b4b',
        contrastText: '#fff'
      },
      all: {
        main: '#000',
        contrastText: '#fff'
      },
    },
    accountForm: {
      created: {
        main: '#ec961b',
        contrastText: '#fff'
      },
      sent: {
        main: '#4bafe8',
        contrastText: '#fff'
      },
      completed: {
        main: '#73c241',
        contrastText: '#fff'
      },
      all: {
        main: '#000',
        contrastText: '#fff'
      },
    },
    taskStatus: {
      update: {
        main: '#4bafe8',
        contrastText: '#fff'
      },
      revert: {
        main: '#b3b3b3',
        contrastText: '#fff'
      },
      pending: {
        main: '#FDB714',
        contrastText: '#fff'
      },
      overdue: {
        main: '#e84b4b',
        contrastText: '#fff'
      },
      completed: {
        main: '#73c241',
        contrastText: '#fff'
      },
      all: {
        main: '#000',
        contrastText: '#fff'
      },
    },
  },
  typography: {
    fontFamily: [
      'Quicksand'
    ],
    fixedWidth: [
      'IBM Plex Mono'
    ],
    body1: {fontSize: '0.875rem'},
  }
});

function Axios({children}) {
  const store = useStore();

  useEffect(() => {
    API.initialise(store);
  }, [store]);
  return <>{children}</>;
}

export default function App() {
  const user = useSelector(state => state['auth'].user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user === false) {
      dispatch(getUser());
    }
  }, [user, dispatch]);

  let router = null;

  if (user !== false) {
    if (user) {
      router = (
        <Router>
          <Switch>
            <Route path="/auth"><Redirect to={`${routes.dashboard}`}/></Route>
            <Route path="/"><Admin/></Route>
          </Switch>
        </Router>
      );
    } else {
      router = (
        <Router>
          <Switch>
            <Route path="/auth"><Access/></Route>
            <Route path="/"><Redirect to={`${routes.login}`}/></Route>
          </Switch>
        </Router>
      )
    }
  }
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Axios>
          {router}
        </Axios>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
